import { Box, Flex, Text, Button, Icon } from '@chakra-ui/react';
import { usePengetahuanDetailContext } from '../../controller/pengetahuan/detail';
import { MdOutlinePlayArrow } from 'react-icons/md';

/**
 * Kuisioner component for displaying questionnaire information and actions.
 *
 * @component
 * @example
 * @author Bagas Prasetyadi
 * return (
 *   <Kuisioner />
 * )
 */

const Kuisioner = () => {
  const { pengetahuanItem } = usePengetahuanDetailContext().state;

  const handleKuisionerClick = () => {
    // Logic untuk membuka kuisioner
    if (pengetahuanItem?.review_url) {
      window.open(pengetahuanItem?.review_url, '_blank');
    }
  };

  return (
    <>
      {pengetahuanItem?.review_url ? (
        <Box
          w="full"
          bg="gray.50"
          rounded="lg"
          p={4}
          border="1px"
          borderColor="gray.400"
        >
          <Flex justifyContent="space-between" alignItems="center">
            <Flex align="center">
              <Box>
                <Text fontSize="md" fontWeight="semibold" color="gray.800">
                  KUISIONER
                </Text>

                <Text fontSize="sm">
                  <Text as="span" color="black" fontSize="inherit">
                    1 Kuisioner -
                  </Text>
                  <Text
                    as="span"
                    fontSize="inherit"
                    fontWeight={'medium'}
                    color={'red.500'}
                  >
                    {' '}
                    wajib mengisi kuisioner
                  </Text>
                </Text>
              </Box>
            </Flex>

            <Button
              colorScheme="blue"
              size="lg"
              rightIcon={<Icon as={MdOutlinePlayArrow} fontSize="20" />}
              onClick={handleKuisionerClick}
            >
              Kerjakan
            </Button>
          </Flex>
        </Box>
      ) : null}
    </>
  );
};

export default Kuisioner;
